import React from 'react';
import { useStore } from 'effector-react';
import { queryKeys } from '@queryClient';
import RowModel3d from './RowModel3d';
import FetchList from './FetchList';
import { $libSearch } from '../stores/libState';
import SearchList from './SearchList';

function ListModel3d() {
  const query = useStore($libSearch);
  return query ? (
    <SearchList queryKey={queryKeys.libListModel3d} row={RowModel3d} />
  ) : (
    <FetchList queryKey={queryKeys.libListModel3d} row={RowModel3d} />
  );
}

export default ListModel3d;
